<div class="accordion-header-control"    [ngClass]="{
  'accordion-header-control--selected': selected(),
}">
<ng-content></ng-content>
</div>
